var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import './color-cd301f48.js';
import './scroll-spy-57348e46.js';
export { B as Block, a as BlockElement, F as FlowTree, c as FlowTreeNode, b as Module, M as ModuleFlow, P as Polyline, e as enUs, l as label, n as nl, s as storedFiles } from './stored-files-eba2aec3.js';
import { B as BceFile } from './throttle-b429d048.js';
import './validator-57c3f59d.js';
var File = /** @class */ (function (_super) {
    __extends(File, _super);
    function File(id, name, path, blob) {
        var _this = _super.call(this, id, name, blob) || this;
        _this.path = path;
        return _this;
    }
    return File;
}(BceFile));
export { File };
